import React from "react";
import { CustomFormSegmentReportData, FileUploadCustomFormFieldData } from "../../../../amorg-common";
import { Card } from "../../../../designSystem/Card";
import { ReportFieldHeader } from "../../[parm]/_components/ReportFieldHeader";

type FileUploadReportFieldProps = {
    fieldId:string,
    fieldLabel:string,
    segmentReports:CustomFormSegmentReportData[]
}
export function FileUploadReportField(props:FileUploadReportFieldProps):JSX.Element
{
    const data:FileUploadCustomFormFieldData[] = [];
    for(const segmentReport of props.segmentReports)
    {
        const fieldSelections = segmentReport.dataSelections.find(s => s.fieldId === props.fieldId);
        if(fieldSelections)
        {
            for(const fs of fieldSelections.selection)
            {
                if(fs.value)
                {
                    try{
                        const fieldData:FileUploadCustomFormFieldData = JSON.parse(fs.value);
                        if(fieldData && fieldData.status?.stage === 'complete')
                        {
                            data.push(fieldData);
                            console.log(fieldData)
                        }
                    }
                    catch(e)
                    {
                        // do nothing
                    }
                }
            }
        }
    }

    return (
        <section>
            <ReportFieldHeader>{props.fieldLabel}</ReportFieldHeader>
            <Card variant="outlined">
                {data.length} videofiler uploadet
            </Card>
        </section>
    );
}